<template>
    <MainLayout v-if="type == 'Reset'">
        <div class="pagetitle">
            <h1>Mi Perfil</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Perfil</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">

                    <div class="row">

                        <h3 class="m-0 font-weight-bold text-primary col-md-11">Actualizar perfil</h3>

                    </div>

                </div>

                <div class="card-body mt-2">
                    <Atom1Loader v-if="loading" />
                    

                    <form class="row g-3" v-else>

                        <div class="col-md-12">

                            <div class="row">

                                <div class="col-md-12">
                                    <div class="form-floating mt-2">
                                        <input v-model="code" class="form-control" placeholder="Código..."
                                            :class="{ 'is-invalid': v$.code.$error }">
                                        <label>Código de recuperación</label>
                                        <div v-if="v$.code.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.code) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6"> 
                                    <div class="form-floating mt-2">
                                        <input v-model="newPassword" class="form-control" placeholder="Nueva contraseña..."
                                            type="password" :class="{ 'is-invalid': v$.newPassword.$error }">
                                        <label>Nueva contraseña</label>
                                        <div v-if="v$.newPassword.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.newPassword) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">    
                                    <div class="form-floating mt-2">
                                        <input v-model="passwordConfirmation" class="form-control" placeholder="Confirmar contraseña..."
                                            type="password" :class="{ 'is-invalid': v$.passwordConfirmation.$error }">
                                        <label>Confirmar contraseña</label>
                                        <div v-if="v$.passwordConfirmation.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.passwordConfirmation) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="text-center">

                            <button class="btn btn-success mr-2 d-flex align-items-center gap-2" 
                                    @click.prevent="sendCode"
                                    :disabled="resendCodeBtnIsDisabled">                                
                                
                                <span v-if="resendCodeBtnIsDisabled">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Espera {{ formattedTime  }}
                                </span>
                                <span v-else>
                                    Reenviar Código
                                </span>
                            </button>

                            <button class="btn btn-primary" @click.prevent="resetPassword">Actualizar Contraseña</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </MainLayout>

    <GuestLayout v-else>
        <div class="pagetitle">
            <h1>Mi Perfil</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Perfil</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">

                    <div class="row">

                        <h3 class="m-0 font-weight-bold text-primary col-md-11">Actualizar perfil</h3>

                    </div>

                </div>

                <div class="card-body mt-2">
                    <Atom1Loader v-if="loading" />
                    

                    <form class="row g-3" v-else>

                        <div class="col-md-12">

                            <div class="row">

                                <div class="col-md-12">
                                    <div class="form-floating mt-2">
                                        <input :value="email" class="form-control" readonly>
                                        <label>Email</label>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-floating mt-2">
                                        <input v-model="code" class="form-control" placeholder="Código..."
                                            :class="{ 'is-invalid': v$.code.$error }">
                                        <label>Código de recuperación</label>
                                        <div v-if="v$.code.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.code) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6"> 
                                    <div class="form-floating mt-2">
                                        <input v-model="newPassword" class="form-control" placeholder="Nueva contraseña..."
                                            type="password" :class="{ 'is-invalid': v$.newPassword.$error }">
                                        <label>Nueva contraseña</label>
                                        <div v-if="v$.newPassword.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.newPassword) }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">    
                                    <div class="form-floating mt-2">
                                        <input v-model="passwordConfirmation" class="form-control" placeholder="Confirmar contraseña..."
                                            type="password" :class="{ 'is-invalid': v$.passwordConfirmation.$error }">
                                        <label>Confirmar contraseña</label>
                                        <div v-if="v$.passwordConfirmation.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.passwordConfirmation) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="text-center">

                            <button class="btn btn-success mr-2 d-flex align-items-center gap-2" 
                                    @click.prevent="sendCode"
                                    :disabled="resendCodeBtnIsDisabled">                                
                                
                                <span v-if="resendCodeBtnIsDisabled">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Espera {{ formattedTime  }}
                                </span>
                                <span v-else>
                                    Reenviar Código
                                </span>
                            </button>

                            <button class="btn btn-primary" @click.prevent="resetPassword">Actualizar Contraseña</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </GuestLayout>
</template>

<script>
import useValidate from '@vuelidate/core';
import { required, minLength, sameAs } from '@vuelidate/validators';

import MainLayout from '@/layouts/MainLayout';
import GuestLayout from '@/layouts/GuestLayout';
import toastMixin from '@/mixins/toastMixin';
import accountMixin from '@/mixins/accountMixin';
import validatorMixin from '@/mixins/validatorMixin';
import axios from "axios";
import { checkCatch } from "@/utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {

    mixins: [toastMixin, accountMixin, validatorMixin],

    name: 'ResetPassword',

    components: {
        MainLayout,
        GuestLayout,
        Atom1Loader,
    },

    props:{

        type: { type: String,   required: false },
        email: { type: String,  required: false },
    },

    data() {

        return {

            v$: useValidate({ $stopPropagation: true }),

            resendCodeBtnIsDisabled: false,
            remainingTime: 0,
            timer: null,

            loading: false,

            code: '',
            newPassword: '',
            passwordConfirmation: '',
        };
    },

    validations() {

        return {

            newPassword: { required, minLength: minLength(3) },
            passwordConfirmation: { required, minLength: minLength(3), sameAsPassword: sameAs(this.newPassword) },
            code: { required },
        };
    },

    async mounted() {

        if ((this.email != null && this.email.length > 0) || this.type == 'Reset'){

            await this.sendCode();
        }
    },

    methods: {

        async sendCode() {            

            this.loading = true;

            let headers = {};
            let url = `${this.$env.API_BASE_URL}send-reset-code-anonymous/`;
            let data = {
                email: this.email
            };

            if (this.type == 'Reset') {

                url = `${this.$env.API_BASE_URL}send-reset-code/`;

                headers = {

                    'Authorization': `Bearer ${this.accountUser.token}`
                };

                data = {};
            }

            await axios.post(url, data, { headers })
                .then(() => {

                    this.startTimer();
                    this.loading = false;

                    this.showNotification({
                        title: 'Atención',
                        description: 'Se ha enviado un código a su correo electrónico para la recuperación de contraseña.',
                        timeout: 30,
                        type: 'info'
                    });

                }).catch((error) => {

                    checkCatch(error);
                });
        },

        async resetPassword() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            const data = {
                
                code: this.code,
                new_password: this.newPassword,
                confirm_password: this.passwordConfirmation,
                email: this.email
            };

            let headers = {}

            if (this.type == 'Reset') {

                headers = {

                    'Authorization': `Bearer ${this.accountUser.token}`
                };
            }

            await axios.put(`${this.$env.API_BASE_URL}update-password/`, data, { headers })
                .then((response) => {
                    
                    const { data } = response;

                    localStorage.removeItem("token"); // Limpiar el token
                    localStorage.setItem("token", data.token); // Guardar el token

                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Contraseña actualizada con éxito',
                        timeout: 4,
                    });
                    
                    this.$router.push('/login');

                }).catch((error) => {

                    checkCatch(error);
                });

        },

        startTimer() {
      
            this.resendCodeBtnIsDisabled = true;
            this.remainingTime = 120;

            this.timer = setInterval(() => {

                this.remainingTime--;

                if (this.remainingTime <= 0) {

                    clearInterval(this.timer);
                    this.resendCodeBtnIsDisabled = false;
                }

            }, 1000);
        },

        pad(value) {    

            return value.toString().padStart(2, '0');
        },
    },

    computed: {

        formattedTime() {

            const minutes = Math.floor(this.remainingTime / 60);
            const seconds = this.remainingTime % 60;
            return `${this.pad(minutes)}:${this.pad(seconds)}`;
        }
    },

    beforeUnmount() {

        if (this.timer) {

            clearInterval(this.timer);
        }
    },
};
</script>

<style scoped>
    button[disabled] {
    cursor: not-allowed;
    opacity: 0.7;
    }
</style>